@if (!addCreatorsMode()) {

@if (hasInquiries() && !showAddCreatorPicker()) {

<div
    class="h-full flex flex-col overflow-hidden w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow flex flex-col min-h-0 rounded-xl border border-border shadow-sm">
    <div class="shrink-0 border-b border-gray-200 px-3 py-3 dark:border-white/10 shrink-0 bg-muted/50">
        <div class="flex flex-row items-center justify-between ">
            <div class="flex-1 flex flex-row items-center justify-start gap-x-2">

                <div class="flex flex-col items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 text-accent">
                        <circle cx="10" cy="7" r="4" />
                        <path d="M10.3 15H7a4 4 0 0 0-4 4v2" />
                        <circle cx="17" cy="17" r="3" />
                        <path d="m21 21-1.9-1.9" />
                    </svg>
                </div>
                <div class="flex flex-col">
                    <h3 class="text-sm font-semibold text-primary">Creators being screened</h3>
                    <p class="hidden sm:block mt-0.5 text-xs text-secondary">{{ creatorRows().length }} creators in this
                        cohort. The ring is how much of their content has been
                        evaluated; the counters show what's been checked and what tripped a rule.</p>
                </div>
            </div>
            <div class="flex min-w-0 shrink-0 gap-2 overflow-x-auto scrollbar-transparent" role="group"
                aria-label="Sort creators">
                <p class="m-0 mr-1 self-center text-xs font-bold uppercase tracking-wide text-muted-foreground">Sort
                    by</p>
                @for (option of sortOptions; track option.id) {
                <button type="button" (click)="setSort(option.id)" [attr.aria-pressed]="sort() === option.id"
                    class="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 dark:focus-visible:outline-gray-200"
                    [class]="sortButtonClass(option.id)">
                    {{ option.label }}
                </button>
                }
            </div>
        </div>
    </div>
    <div class="min-h-0 flex-1 overflow-y-auto p-4 scrollbar-transparent">
        <ul role="list"
            class="m-0 grid list-none auto-rows-min content-start items-start gap-3.5 p-0 md:grid-cols-2 xl:grid-cols-3">
            @for (row of sortedCreators(); track row.inquiryId) {
            <li>
                <scr-creator-card [creator]="row" [briefId]="focussedScreeningBriefId" />
            </li>
            }
        </ul>
    </div>
    <div class="shrink-0 border-t border-gray-200 px-3 py-2 dark:border-white/10 shrink-0 bg-muted/50">
        <div class="flex flex-row items-center justify-between">
            <div></div>
            <div class="flex flex-row items-center justify-end">
                <button type="button" (click)="openAddCreatorPicker()"
                    class="primary-button inline-flex flex-row items-center gap-x-2">
                    Add Creators
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <line x1="19" x2="19" y1="8" y2="14" />
                        <line x1="22" x2="16" y1="11" y2="11" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>
} @else {
<div class="h-full flex-1 flex flex-col gap-y-4 items-center justify-center w-full overflow-hidden">
    @if (showAddCreatorPicker() && !hasInquiries()) {
    <div class="w-full max-w-2xl flex flex-row items-center justify-start">
        <button (click)="closeAddCreatorPicker()" type="button" class="fab-button-secondary"
            aria-label="Back to creators list">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
            </svg>
        </button>
    </div>
    }

    @if (!hasInquiries()) {
    <div class="max-w-2xl text-center">
        <div
            class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-cyan-100 dark:bg-cyan-900/30 mb-6">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-10 text-cyan-600 dark:text-cyan-400">
                <path
                    d="M20 10V8a2.4 2.4 0 0 0-.706-1.704l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4.35" />
                <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                <path d="M16 14a2 2 0 0 0-2 2" />
                <path d="M16 22a2 2 0 0 1-2-2" />
                <path d="M20 14a2 2 0 0 1 2 2" />
                <path d="M20 22a2 2 0 0 0 2-2" />
            </svg>
        </div>
        <h2 class="text-2xl font-semibold text-primary mb-4">No Creators Yet</h2>
        <p class="text-base text-secondary leading-relaxed mb-6 mx-8">
            Please add creators to the screening brief to get started.
        </p>
    </div>
    }

    <div>
        <h2 class="text-base/7 font-semibold text-primary">How would you like to add creators?</h2>
        <p class="text-sm/6 text-secondary">Choose one of the options to below to add creators.
        </p>

        <ul role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-3 sm:gap-6">
            @for (item of addCreatorOptions; track $index) {
            <li class="col-span-1 flex rounded-md border-zinc-500 cursor-pointer hover:scale-105 transition-all duration-300"
                (click)="selectCreatorOption(item)">
                <div class="flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium cursor-pointer"
                    [class]="item.class">
                    @switch (item.id) {
                    @case (1) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <circle cx="10" cy="7" r="4" />
                        <path d="M10.3 15H7a4 4 0 0 0-4 4v2" />
                        <circle cx="17" cy="17" r="3" />
                        <path d="m21 21-1.9-1.9" />
                    </svg>
                    }
                    @case (2) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <rect width="13" height="7" x="8" y="3" rx="1" />
                        <path d="m2 9 3 3-3 3" />
                        <rect width="13" height="7" x="8" y="14" rx="1" />
                    </svg>
                    }
                    @case (3) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <path d="M12 3v12" />
                        <path d="m17 8-5-5-5 5" />
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    </svg>
                    }
                    @case (4) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <path d="M16 5H3" />
                        <path d="M16 12H3" />
                        <path d="M11 19H3" />
                        <path d="m15 18 2 2 4-4" />
                    </svg>
                    }
                    }
                </div>

                <div
                    class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10 cursor-pointer">
                    <div class="flex-1 truncate px-4 py-2 text-sm">
                        <a class="font-medium text-primary hover:text-gray-200">{{ item.name
                            }}</a>
                        <p class="text-secondary truncate">{{ item.description }}</p>
                    </div>
                </div>
            </li>
            }
        </ul>

        @if (showAddCreatorPicker() && hasInquiries()) {
        <div class="w-full flex flex-row items-center justify-start gap-x-2 mt-2">
            <button (click)="closeAddCreatorPicker()" type="button"
                class="secondary-button text-primary inline-flex flex-row items-center gap-x-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
                Cancel</button>
        </div>
        }
    </div>




</div>
}

} @else {
<div
    class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4 border-t border-gray-200 dark:border-gray-700 pt-2 ">
    <div class="flex-0 flex flex-row items-center justify-between w-full">
        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="addCreatorsMode.set(false)" type="button" class="fab-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                </svg>
            </button>

            <div class="">
                <div class="inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary">Add Creators
                    </h3>
                </div>
                <p class="mt-0 text-xs text-secondary">Which creators are you screening?</p>
            </div>
        </div>

        <div class="flex flex-row items-center justify-end gap-x-4">
            <div class="">
                <nav aria-label="Tabs" class="flex space-x-2">
                    <a (click)="creatorModeTab.set(1)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(1)">Search Creators</a>
                    <!-- <a (click)="creatorModeTab.set(2)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                            [class]="getTabClass(2)">Add Manually</a> -->
                    <a (click)="creatorModeTab.set(3)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass(3)">Upload CSV</a>
                    <!-- <a (click)="creatorModeTab.set(4)" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                            [class]="getTabClass(4)">Existing List</a> -->
                </nav>

            </div>
        </div>

    </div>
    <!-- Main Tabbed Section -->
    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
        @switch (creatorModeTab()) {
        @case (1) {
        <mc-search-creators class="w-full h-full"></mc-search-creators>
        }
        @case (2) {
        <!-- <mc-add-manually></mc-add-manually> -->
        }
        @case (3) {
        <mc-upload-csv class="w-full h-full" [focussedScreeningBriefId]="focussedScreeningBriefId"
            (close)="addCreatorsMode.set(false)" (listUploaded)="listUploaded($event)"></mc-upload-csv>
        }
        @case (4) {
        <rg-group-picker class="h-full w-full" [mode]="'attach-to-brief'"
            [briefContext]="{ kind: 'screening', briefId: focussedScreeningBriefId }"
            (attached)="creatorListSetOut.emit(true)"></rg-group-picker>
        }
        }
    </div>
</div>
}